export default __webpack_public_path__ + "static/media/prof-Img_defaultSquid.8eebec42.png";